import React from "react";
import parse from "html-react-parser";

const HelpModal = ({ content, btn_text, onPress }) => {
  return (
    <div className="help-how-work" onClick={onPress}>
      <div className="modal-inner" onClick={(e) => e.stopPropagation()}>
        <div className="content-div">{parse(content)}</div>
        <div className="btn-div">
          <button onClick={onPress} className="help-ok-btn">
            {btn_text}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpModal;
